import * as React from "react";

const ChevronIconSecondary = (props: any) => (
  <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15.1801 19.4817L7.58984 11.8914L9.36091 10.1204L15.1801 15.9396L20.9993 10.1204L22.7704 11.8914L15.1801 19.4817Z" fill="#6C4B28" />
  </svg>
);

export default ChevronIconSecondary;
